import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { TuiAlertService } from '@taiga-ui/core';
import { TuiPushService } from '@taiga-ui/kit';
import {
  BehaviorSubject,
  EMPTY,
  finalize,
  Observable,
  Subject,
  switchMap,
  take,
  tap,
  throwError,
} from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { getCurrentUser } from '@store/actions/current_user.actions';
import { getGeozones } from '@store/geozones/geozones.actions';

import { Geozone, GeozoneTypeEnum } from '../app/portal/components/map/types/geozoneTypes';

export type GeozoneImportSource = 'axenta' | 'wialon' | 'other';

export interface GeozonesGroupItem {
  accountId: number;
  creatorId: number;
  id: number;
  name: string;
  description: string | null;
  tiedGeozones: number[];
}

export type GeozonesGroupsList = GeozonesGroupItem[];

@Injectable({
  providedIn: 'root',
})
export class GeozonesService {
  protected readonly push = inject<TuiPushService>(TuiPushService);
  private readonly alerts = inject<TuiAlertService>(TuiAlertService);
  private readonly httpClient = inject(HttpClient);
  private readonly translate = inject(TranslateService);
  private readonly store = inject(Store);

  public createGeozoneFormVisible: BehaviorSubject<{
    isActive: boolean;
    action: 'create' | 'edit' | 'duplicate' | null;
  }> = new BehaviorSubject<{ isActive: boolean; action: 'create' | 'edit' | 'duplicate' | null }>({
    isActive: false,
    action: null,
  });
  public editedGeozone: BehaviorSubject<Geozone<GeozoneTypeEnum> | null> =
    new BehaviorSubject<Geozone<GeozoneTypeEnum> | null>(null);
  public createGeozoneSquare: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public createGeozonePerimeter: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public createGeozonePerimeterMeters: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public createGeozoneRadius: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  public createGeozoneDestroyer = new Subject();
  public deleteGeozone: Subject<number> = new Subject<number>();
  public goToGeozoneBounds: Subject<number> = new Subject<number>();

  public currentDrawLayer: any = null;

  public actionGeozoneText = 'Creating geofence';

  public unsavedFileNames: string[] = [];

  createGeozone(body: any) {
    return this.httpClient.post('geozone/', body);
  }

  updateGeozone(geozoneId: number, body: any) {
    return this.httpClient.put(`geozone/${geozoneId}/`, body);
  }

  createGeozonesGroup(body: any) {
    return this.httpClient.post('geozones/groups/', body);
  }

  getGeozonesList() {
    return this.httpClient.get<Geozone<GeozoneTypeEnum>[]>('geozone/');
    //   .pipe(
    //   map((geozones) => {
    //     const simplificationStats: Record<string, number> = {};
    //     const bigGeo = geozones
    //       .filter(
    //         (geozone) =>
    //           geozone.type === GeozoneTypeEnum.Line && (geozone?.geo as Array<any>)?.length > 1000,
    //       )
    //       .map((geozone) => ({
    //         name: geozone.name,
    //         geoLength: (geozone?.geo as Array<any>)?.length,
    //       }))
    //       .sort((a, b) => a.geoLength - b.geoLength);
    //
    //     console.warn(bigGeo);
    //     const result = geozones
    //       // .filter(
    //       //   (geozone) =>
    //       //     !(
    //       //       geozone.type === GeozoneTypeEnum.Line && (geozone?.geo as Array<any>)?.length > 1000
    //       //     ),
    //       // )
    //       .map((geozone) => {
    //         // Применяем алгоритм Дугласа-Пекера только для линий
    //         if (geozone.type === GeozoneTypeEnum.Line && Array.isArray(geozone.geo)) {
    //           const originalPointsCount = geozone.geo.length;
    //
    //           // Динамический расчет tolerance в зависимости от количества точек
    //           let tolerance: number;
    //           if (originalPointsCount < 50) {
    //             tolerance = 0.00005; // Минимальное упрощение для коротких линий
    //           } else if (originalPointsCount < 200) {
    //             tolerance = 0.0001; // Среднее упрощение
    //           } else if (originalPointsCount < 500) {
    //             tolerance = 0.0002; // Усиленное упрощение
    //           } else if (originalPointsCount < 1000) {
    //             tolerance = 0.0004; // Агрессивное упрощение
    //           } else {
    //             tolerance = 0.0006; // Максимальное упрощение для очень длинных линий
    //           }
    //
    //           const simplifiedGeo = douglasPeucker(geozone.geo, tolerance);
    //           simplificationStats[`${geozone?.name}_${originalPointsCount}`] = simplifiedGeo.length;
    //
    //           return {
    //             ...geozone,
    //             geo: simplifiedGeo,
    //           };
    //         }
    //         // Для окружностей и полигонов возвращаем без изменений
    //         return geozone;
    //       });
    //
    //     // Выводим статистику упрощения в консоль
    //     const test = Object.keys(simplificationStats);
    //     if (test.length > 0) {
    //       console.log(
    //         `📊 Статистика упрощения геозон (было точек → стало точек) ${test.length} :`,
    //         simplificationStats,
    //       );
    //     }
    //
    //     return result;
    //   }),
    // );
  }

  geozonesGroupList(): Observable<GeozonesGroupsList> {
    return this.httpClient.get<GeozonesGroupsList>('geozones/groups/');
  }

  updateGeozonesGroup(body: any, geozone_id: number) {
    return this.httpClient.put(`geozones/groups/${geozone_id}/`, body);
  }

  delete(geozone_id: number) {
    return this.httpClient.delete(`geozone/${geozone_id}/`);
  }

  deleteGroupGeozones(geozone_id: number) {
    return this.httpClient.delete(`geozones/groups/${geozone_id}/`);
  }

  changeDisplayGeozonesByIds(visibleGeozoneIds: number[]) {
    return this.httpClient.post('geozone/display/', { visibleGeozoneIds });
  }

  sendObjectsData(coordinates: any) {
    return this.httpClient.post('geozone/objects_inside/', { coordinates });
  }

  checkImportFile(file: File, source: GeozoneImportSource): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('source', source);

    return this.httpClient.post('geozone/import/get_geozone_names_from_file/', formData);
  }

  importGeozones(body: {
    fileUuid: string;
    selectedGeozones: number[];
    source: GeozoneImportSource;
  }): Observable<any> {
    return this.httpClient.post('geozone/import/', body);
  }

  exportGeozones(body: { geozoneIds: number[]; fileExtension: 'KML' | 'KMZ'; fileName: string }) {
    return this.httpClient
      .post(`geozone/export/`, body)
      .pipe(finalize(() => this.unsavedFileNames.push(body.fileName)));
  }

  exportGeozonesAndSave(body: {
    geozoneIds: number[];
    fileExtension: 'KML' | 'KMZ';
    fileName: string;
  }): Observable<Blob> {
    return this.httpClient
      .post(`geozone/export/`, body, {
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(
        tap((response) => {
          const contentDisposition = response.headers.get('Content-Disposition');
          const { fileName, fileFormat } = this.extractFileNameAndFormat(contentDisposition);
          this.saveGeozonesFile(response.body!, fileName, fileFormat);
        }),
        catchError((error) => {
          if (error instanceof Blob) {
            this.handleBlobError(error);
          } else {
            console.error('Ошибка при загрузке файла:', error);
          }
          return throwError(() => error);
        }),
        map((response) => response.body!),
      );
  }

  getExportedFileByTaskId(taskId: string) {
    return this.httpClient
      .get(`geozone/export/download/${taskId}/`, {
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(
        tap((response) => {
          const contentDisposition = response.headers.get('Content-Disposition');
          const { fileName, fileFormat } = this.extractFileNameAndFormat(contentDisposition);

          this.saveGeozonesFile(response.body!, fileName, fileFormat);
        }),
        catchError((error) => {
          if (error instanceof Blob) {
            this.handleBlobError(error);
          } else {
            console.error('Ошибка при загрузке файла:', error);
          }
          return throwError(() => error);
        }),
      );
  }

  private extractFileNameAndFormat(contentDisposition: string | null): {
    fileName: string;
    fileFormat: string;
  } {
    let fileName = 'default_name';
    let fileFormat = 'kml';

    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (fileNameMatch?.[1]) {
        const rawFileName = fileNameMatch[1].replace(/['"]/g, '');
        const decodedFileName = decodeURIComponent(rawFileName);

        const parts = decodedFileName.split('.');
        if (parts.length > 1) {
          fileFormat = parts.pop() || 'kml';
          fileName = parts.join('.');
        } else {
          fileName = decodedFileName;
        }
      }
    }

    return { fileName, fileFormat };
  }

  saveGeozonesFile(blob: Blob, fileName: string, fileFormat: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.${fileFormat}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  handleGeozoneImportResult(res: any): void {
    const failedGeozonesCount =
      Object.keys(res.failedGeozones || {}).length + res.failedGeozonesNames.length;
    const savedGeozonesCount = res.savedGeozonesCount ?? 0;
    const requestedAmount = res.requestedAmount ?? 0;

    const message = this.translate.instant('geozonesImportSuccess', {
      saved: savedGeozonesCount,
      total: requestedAmount,
    });
    if (!failedGeozonesCount && savedGeozonesCount) {
      this.alerts.open(message).subscribe();
    } else {
      const downloadButton = this.translate.instant('Download the error report');
      const pushType = this.translate.instant('geozonesImportCompletedWithErrors');
      this.push
        .open(message, {
          type: pushType,
          icon: '@tui.circle-alert',
          buttons: [downloadButton],
        })
        .pipe(
          take(1),

          switchMap((button) => {
            if (button === downloadButton) {
              this.generateFailedGeozonesReport({
                failedGeozones: res.failedGeozones || {},
                failedGeozonesNames: res.failedGeozonesNames || [],
                savedGeozonesCount: res.savedGeozonesCount || '?',
                requestedAmount: res.requestedAmount || '',
              });
            }
            return EMPTY;
          }),
        )
        .subscribe();
    }

    this.store.dispatch(getGeozones());
    this.store.dispatch(getCurrentUser());
  }

  private handleBlobError(error: Blob): void {
    if (error.type === 'application/json') {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const errorData = JSON.parse(reader.result as string);
          if (errorData?.formError?.taskId) {
            const message = errorData?.formError?.taskId;
            this.alerts.open(message, { appearance: 'warning', autoClose: 6000 }).subscribe();
          }
        } catch (e) {
          console.error('Ошибка при разборе JSON:', e);
        }
      };
      reader.readAsText(error);
    } else {
      console.log('handleBlobError', error);
    }
  }

  generateFailedGeozonesReport(data: {
    failedGeozones: Record<number, string>;
    failedGeozonesNames: string[];
    savedGeozonesCount?: number;
    requestedAmount?: number;
  }) {
    const {
      failedGeozones,
      failedGeozonesNames,
      savedGeozonesCount = 0,
      requestedAmount = 0,
    } = data;

    const totalFailed = Object.keys(failedGeozones).length + failedGeozonesNames.length;

    const title = this.translate.instant('geozonesImport.resultTitle');
    const totalProcessedLabel = this.translate.instant('geozonesImport.totalProcessed');
    const successImportedLabel = this.translate.instant('geozonesImport.successImported');
    const failedLabel = this.translate.instant('geozonesImport.failedCount');
    const failedNamesHeader = this.translate.instant('geozonesImport.failedNamesHeader');
    const allOkText = this.translate.instant('geozonesImport.allOk');

    let reportContent = `${title}\n\n`;
    reportContent += `${totalProcessedLabel}: ${requestedAmount}\n`;
    reportContent += `${successImportedLabel}: ${savedGeozonesCount}\n`;
    reportContent += `${failedLabel}: ${totalFailed}\n\n`;
    reportContent += `${failedNamesHeader}\n`;

    const allFailedNames: string[] = [...Object.values(failedGeozones), ...failedGeozonesNames];
    reportContent += allFailedNames.length ? allFailedNames.join('\n') : allOkText;

    const blob = new Blob([reportContent], { type: 'text/plain;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'failed_geozones_list.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
}
